import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "New Foursquare [screengrab porn]",
  "description": "",
  "published": "2012-06-07T00:00:00.000Z",
  "redirect_from": ["/blog/new-foursquare-screengrab-porn/swizec/4588"],
  "categories": "Android, App Store, Button, Check-in, Explore, Foursquare, IPhone, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today `}<a parentName="p" {...{
        "href": "http://www.foursquare.com/",
        "title": "Foursquare"
      }}>{`Foursquare`}</a>{` released a completely revamped version of their iPhone app.`}</p>
    <p>{`And it's `}<em parentName="p">{`awesome`}</em>{`. If you're on Android you can only hope yours gets updated soon. The whole interface is just more pleasant to use, there are less buttons - less buttons is always good, even though I'm a geek - everything is less cramped and there is a bigger emphasis on useful info rather than friends.`}</p>
    <p>{`The explore feature has now become genuinely useful as well - love it.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/4sq-home-screen.png",
        "alt": "4sq home screen",
        "title": "4sq home screen"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/4sq-explore.png",
        "alt": "4sq explore",
        "title": "4sq explore"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/4sq-explore2.png",
        "alt": "4sq explore",
        "title": "4sq explore"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/4sq-explore-topics.png",
        "alt": "4sq explore topics",
        "title": "4sq explore topics"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/4sq-venue.png",
        "alt": "4sq venue",
        "title": "4sq venue"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/4sq-venue-tips.png",
        "alt": "4sq venue tips",
        "title": "4sq venue tips"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/4sq-profile.png",
        "alt": "4sq profile",
        "title": "4sq profile"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/4sq-user-tips.png",
        "alt": "4sq user tips",
        "title": "4sq user tips"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thenextweb.com/apps/2012/06/07/the-all-new-foursquare-launches-to-cash-in-on-making-the-real-world-easier-to-use/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/92862946_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://thenextweb.com/apps/2012/06/07/the-all-new-foursquare-launches-to-cash-in-on-making-the-real-world-easier-to-use/"
        }}>{`The all new foursquare launches to cash in on "making the real world easier to use"`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.businessinsider.com/foursquares-major-redesign-is-live-heres-everything-that-has-changed-2012-6"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/92848276_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.businessinsider.com/foursquares-major-redesign-is-live-heres-everything-that-has-changed-2012-6"
        }}>{`Foursquare's Major Redesign Is Live: Here's Everything That Has Changed`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.slashgear.com/foursquare-revamps-ios-app-with-focus-on-discovery-07232716/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/92894664_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.slashgear.com/foursquare-revamps-ios-app-with-focus-on-discovery-07232716/"
        }}>{`Foursquare revamps iOS app with focus on discovery`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//www.gadgetbox.msnbc.msn.com/technology/gadgetbox/foursquare-no-longer-just-about-where-you-are-also-about-816929&a=92852197&rid=51d45650-39ed-45dd-9fe7-b4d304abe32e&e=df43427394c77d7e0c56968f45216301"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/92852197_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//www.gadgetbox.msnbc.msn.com/technology/gadgetbox/foursquare-no-longer-just-about-where-you-are-also-about-816929&a=92852197&rid=51d45650-39ed-45dd-9fe7-b4d304abe32e&e=df43427394c77d7e0c56968f45216301"
        }}>{`Foursquare app redesign aims to guide users to new places - @msnbc_tech`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://searchengineland.com/foursquare-rolls-out-app-redo-new-likes-better-recommendations-more-engagement-options-123778"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/92852755_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://searchengineland.com/foursquare-rolls-out-app-redo-new-likes-better-recommendations-more-engagement-options-123778"
        }}>{`Foursquare Rolls Out App Redo: New Likes, Better Recommendations, Visually Simpler`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=51d45650-39ed-45dd-9fe7-b4d304abe32e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      